import {
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
  Button,
} from '@mui/material';
import { ModalNotificationProps } from 'src/features/inAppNotifications/presentation/components/ModalNotification/ModalNotification.types';
import ModalNotificationContent from 'src/features/inAppNotifications/presentation/components/ModalNotification/ModalNotificationContent';

const ModalNotification: React.FC<ModalNotificationProps> = ({
  open,
  onClose,
  notification,
  onContentClick: handleContentClick,
}) => {
  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      sx={{ m: { md: 'auto', xs: 1.5 }, maxWidth: 'md' }}
      PaperProps={{
        sx: {
          padding: 2,
          alignItems: 'center',
          textAlign: 'center',
          width: '100%',
          m: 0,
        },
      }}
    >
      <DialogContent>
        <ModalNotificationContent
          notification={notification}
          onClick={handleContentClick}
        />
        <Typography variant="h2" textAlign="center" py={1}>
          {notification.title}
        </Typography>
        <Typography
          textAlign="center"
          variant="body1"
          fontWeight="fontWeightMedium"
          lineHeight={1.2}
        >
          {notification.message}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          size="large"
          sx={{
            width: '100%',
            maxWidth: 360,
            alignSelf: 'center',
          }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalNotification;
